module.exports = __webpack_public_path__ + "static/navbar_desktop-25f73f4922f03966caab672568451489.png";